module.exports = __webpack_public_path__ + "static/media/3040.1151365a.jpg";